export const PROJECTS_SET_STATE = 'PROJECTS_SET_STATE';
export const SELECT_ENGAGEMENT = 'SELECT_ENGAGEMENT';
export const SELECT_PROJECT = 'SELECT_PROJECT';
export const SEARCH_PROJECTS = 'SEARCH_PROJECTS';

export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_ERROR = 'GET_PROJECTS_ERROR';

export const GET_PROJECT_FILES = 'GET_PROJECT_FILES';
export const GET_PROJECT_FILES_REQUEST = 'GET_PROJECT_FILES_REQUEST';
export const GET_PROJECT_FILES_SUCCESS = 'GET_PROJECT_FILES_SUCCESS';
export const GET_PROJECT_FILES_ERROR = 'GET_PROJECT_FILES_ERROR';

export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';

export const CREATE_ENGAGEMENT = 'CREATE_ENGAGEMENT';
export const CREATE_ENGAGEMENT_REQUEST = 'CREATE_ENGAGEMENT_REQUEST';
export const CREATE_ENGAGEMENT_SUCCESS = 'CREATE_ENGAGEMENT_SUCCESS';
export const CREATE_ENGAGEMENT_ERROR = 'CREATE_ENGAGEMENT_ERROR';

export const EDIT_PROJECT = 'EDIT_PROJECT';
export const EDIT_PROJECT_REQUEST = 'EDIT_PROJECT_REQUEST';
export const EDIT_PROJECT_SUCCESS = 'EDIT_PROJECT_SUCCESS';
export const EDIT_PROJECT_ERROR = 'EDIT_PROJECT_ERROR';

export const EDIT_ENGAGEMENT = 'EDIT_ENGAGEMENT';
export const EDIT_ENGAGEMENT_REQUEST = 'EDIT_ENGAGEMENT_REQUEST';
export const EDIT_ENGAGEMENT_SUCCESS = 'EDIT_ENGAGEMENT_SUCCESS';
export const EDIT_ENGAGEMENT_ERROR = 'EDIT_ENGAGEMENT_ERROR';

export const DELETE_PROJECT = 'DELETE_PROJECT';
export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR';

export const DELETE_ENGAGEMENT = 'DELETE_ENGAGEMENT';
export const DELETE_ENGAGEMENT_REQUEST = 'DELETE_ENGAGEMENT_REQUEST';
export const DELETE_ENGAGEMENT_SUCCESS = 'DELETE_ENGAGEMENT_SUCCESS';
export const DELETE_ENGAGEMENT_ERROR = 'DELETE_ENGAGEMENT_ERROR';



// WEBPACK FOOTER //
// ./src/state/projects/types.js